module.exports = __WEBPACK_EXTERNAL_MODULE__babylonjs_core_Misc_decorators__;